import api from '../services/ApiService';
import auth from '../services/AuthService';

// app
export const GET_INFO = 'GET_INFO';
export const GET_MENU_TREE = 'GET_MENU_TREE';
export const GET_SEARCH_DATA = 'GET_SEARCH_DATA';
export const SET_SHOW_HELP = 'SET_SHOW_HELP';

// users
export const GET_USER = 'GET_USER';
export const SET_USER = 'SET_USER';
export const SET_BRANCH = 'SET_BRANCH';
export const SET_CODES = 'SET_CODES';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const REMOVE_USER_DATA = 'REMOVE_USER_DATA';

// favorites
export const ADD_FAVORITE = 'ADD_FAVORITE';
export const REMOVE_FAVORITE = 'REMOVE_FAVORITE';
export const UPDATE_FAVORITES = 'UPDATE_FAVORITES';
export const UPDATE_FAVORITELIST = 'UPDATE_FAVORITELIST';

// notifications
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const MARK_NOTIFICATION = 'MARK_NOTIFICATION';

// modals
export const GET_MODAL_CONFIGS = 'GET_MODAL_CONFIGS';

export const SET_AVATAR = 'SET_AVATAR';

export function addFavorite(pageName) {
  return {
    type: ADD_FAVORITE,
    payload: api.post(`/menu/favorite/${pageName}`),
  };
}

export function removeFavorite(pageName) {
  return {
    type: REMOVE_FAVORITE,
    payload: api.delete(`/menu/favorite/${pageName}`),
  };
}

export function updateFavorites(listId, favorites) {
  return {
    type: UPDATE_FAVORITES,
    payload: api.put(`/favorites/list/${listId}`, favorites),
  };
}

export function updateFavoriteList(favoriteListId, list) {
  return {
    type: UPDATE_FAVORITELIST,
    payload: api.put('/favorites', { favoriteListId, list }),
  };
}

export function getInfo() {
  return {
    type: GET_INFO,
    payload: api.get('/appinfo'),
  };
}

export function getUser() {
  return {
    type: GET_USER,
    payload: api.get('/user/me'),
  };
}

export function setUser(user) {
  return {
    type: SET_USER,
    payload: user,
  };
}

export function setBranch(branch) {
  return {
    type: SET_BRANCH,
    payload: branch,
  };
}

export function getSearchData() {
  return {
    type: GET_SEARCH_DATA,
    payload: api.get('search/page'),
  };
}

export function getMenuTree() {
  return {
    type: GET_MENU_TREE,
    payload: api.get('menutree'),
  };
}

export function getModalConfigs() {
  return {
    type: GET_MODAL_CONFIGS,
    payload: api.get('drilldown/views'),
  };
}

export function login(username, password) {
  return {
    type: LOGIN_USER,
    payload: auth.login(username, password),
  };
}

export function logout() {
  return {
    type: LOGOUT_USER,
  };
}

export function changePassword(password, token = '') {
  return {
    type: CHANGE_PASSWORD,
    payload: auth.changePassword(password, token),
  };
}

export function updateUserData(key, data) {
  return {
    type: UPDATE_USER_DATA,
    payload: api.put('user/data', { key, data }),
    meta: {
      key,
      data,
    },
  };
}

export function removeUserData(key) {
  return {
    type: REMOVE_USER_DATA,
    payload: api.delete('user/data', { params: { key } }),
    meta: {
      key,
    },
  };
}

export function markDone(noteId) {
  return {
    type: MARK_NOTIFICATION,
    payload: api.post(`/notifications/${noteId}/mark`),
  };
}

export function addNote(note = {}) {
  return {
    type: ADD_NOTIFICATION,
    payload: note,
  };
}

export function removeNote(noteId) {
  return {
    type: REMOVE_NOTIFICATION,
    payload: api.delete(`/notifications/${noteId}`),
  };
}

export function setAvatar(avatar) {
  return {
    type: SET_AVATAR,
    payload: api.put('user/avatar', avatar),
  };
}

export function setShowHelp(showHelp) {
  return {
    type: SET_SHOW_HELP,
    value: showHelp,
  };
}
